<!-- <div class="content">
	<div class="container-fluid">
		<div class="row" *ngIf="backbutton.show">
			<div class="col-md-12">
				<button class="btn btn-primary m-2" [routerLink]="[backbutton.link]">
					<i class="fas fa-chevron-left"></i> Atrás
				</button>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<button *ngIf="!statusevent" class="btn bg-primary btn-sm btn-app m-2" (click)="regargar()"> <i class="fas fa-sync-alt"></i>Recargar</button>
				<button *ngIf="statusevent" class="btn bg-primary btn-sm btn-app m-2" disabled> <i class="fas fa-sync-alt fa-spin"></i></button>
			</div>
		</div>
	</div>
</div> -->
<div class="content">
	<div class="container-fluid">
		<div class="row" *ngIf="backbutton.show">
			<div class="col-md-12">
				<button class="btn btn-primary m-2" [routerLink]="[backbutton.link]" (click)="eliminarRutaprevia()">
					<i class="fas fa-chevron-left"></i> Atrás
				</button>

				<button *ngIf="!statusevent" class="btn btn-primary ml-1" (click)="regargar()">
					<i class="fas fa-sync-alt"></i>
				</button>
				<button *ngIf="statusevent" class="btn btn-primary ml-1" disabled>
					<i class="fas fa-sync-alt fa-spin"></i>
				</button>

				
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<button *ngIf="!statusevent" class="btn bg-primary btn-sm m-2" (click)="regargar()"> <i class="fas fa-sync-alt mr-1"></i>Recargar</button>
				<button *ngIf="statusevent" class="btn bg-primary btn-sm m-2" disabled> <i class="fas fa-sync-alt fa-spin"></i></button>
			</div>
		</div>
	</div>
</div>